
import { Options, Vue } from 'vue-class-component';

@Options({
    emits: ['click'],
    props: {
        label: {
            type: String,
        },
        disabled: {
            type: Boolean,
        },
        tabindex: {
            type: String,
        },
        icon: {
            type: String,
        },
        linkIndicator: {
            type: Boolean,
        },
        styles: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        styleClasses() {
            return this.styles
                .map((value: string) => 'button--' + value)
                .join(' ');
        }
    }
})

export default class Button extends Vue {
}
